import React from 'react'
import { cn } from '@craft-agent/ui'

interface Props {
  className?: string
}

export function OmniAppSwitcher({ className }: Props) {
  const onSelect = () => {
    const href = typeof window !== 'undefined' ? window.location.href : '/'
    const theme = typeof document !== 'undefined' && document.documentElement.classList.contains('dark') ? 'dark' : 'light'
    const returnTo = encodeURIComponent(href)
    const themeParam = encodeURIComponent(theme)
    const isAgents = typeof window !== 'undefined' ? window.location.hostname.includes('agents.') : false

    if (isAgents) {
      window.location.href = `https://omnibrief.app?returnTo=${returnTo}&theme=${themeParam}`
    } else {
      window.location.href = `https://agents.omnibrief.app?returnTo=${returnTo}&theme=${themeParam}`
    }
  }

  return (
    <div className={cn('flex items-center gap-1 cursor-pointer select-none', className)}>
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-semibold hover:bg-muted transition"
        onClick={onSelect}
      >
        Switch Apps
      </button>
      <div className="sr-only">Switch between OMNI and OMNI Agents</div>
    </div>
  )
}
